"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getA11yElement = exports.getA11yValue = exports.a11yClear = exports.a11yUpdate = exports.a11yCreate = void 0;
var get_1 = require("../get/get");
var staticValues_1 = require("../staticValues");
exports.a11yCreate = function (document) {
    var _a;
    if (document === void 0) { document = window.document; }
    var $block = document.createElement('div');
    $block.setAttribute('aria-live', 'polite');
    $block.setAttribute('style', 'position: absolute; opacity: 0; height: 0; width: 0; overflow: hidden; pointer-events: none;');
    $block.id = staticValues_1.a11yID;
    (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.appendChild($block);
    return $block;
};
exports.a11yUpdate = function ($input, announcementArray, document) {
    if (document === void 0) { document = window.document; }
    if (!$input)
        return '';
    exports.a11yClear(document);
    var cursorSegment = get_1.getCursorSegment($input);
    var values = get_1.getInputValue($input).asTimeObject();
    var value = values[cursorSegment];
    var segmentValue = value === null ? 'blank' : value;
    var segmentName = {
        hrs12: 'Hours',
        minutes: 'Minutes',
        mode: 'AM/PM',
    }[cursorSegment];
    var announcements = {
        initial: '$label grouping $fullValue.',
        select: '$segmentName spin button $segmentValue.',
        update: '$segmentValue.',
    };
    var textArray = announcementArray.map(function (key) { return announcements[key]; });
    var fullValue = $input.value.replace(/--/g, 'blank');
    var html = "<p>" + textArray.join('</p><p>') + "</p>";
    var labelText = get_1.getLabelTextOf($input, document);
    html = html.replace(/\$label/g, labelText);
    html = html.replace(/\$segmentName/g, segmentName);
    html = html.replace(/\$segmentValue/g, "" + segmentValue);
    html = html.replace(/\$fullValue/g, fullValue);
    var $a11y = document.getElementById(staticValues_1.a11yID);
    if ($a11y) {
        $a11y.innerHTML = html;
    }
    return html;
};
exports.a11yClear = function (document) {
    if (document === void 0) { document = window.document; }
    var $a11y = document.getElementById(staticValues_1.a11yID);
    if ($a11y) {
        $a11y.innerHTML = '';
    }
};
exports.getA11yValue = function (document) {
    if (document === void 0) { document = window.document; }
    var $a11y = document.getElementById(staticValues_1.a11yID);
    return ($a11y === null || $a11y === void 0 ? void 0 : $a11y.textContent) ? $a11y.textContent : '';
};
exports.getA11yElement = function (document) {
    if (document === void 0) { document = window.document; }
    return document.getElementById(staticValues_1.a11yID);
};
